/*
 * Module for the Death Beneficiaries Step of the MemberDirect Retirement Application wizard
*/
rs.module("content/benefits/retirementapplication/deathbeneficiariesstep",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, listApi) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var addDeathBeneficiaryLink = stepContainer.js(jsSelectors.addDeathBeneficiaryLink);
            var deathBeneficiaryActionKeyHidden = stepContainer.js(jsSelectors.deathBeneficiaryActionKeyHidden);

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // Get the form (this will be the wizard form)
            var _form = stepContainer.closest("form");

            // Reset validation
            $.validator.resetValidation(_form);

            // Handle the addDeathBeneficiaryLink click event
            addDeathBeneficiaryLink.on('click', function () {

                // Set the death beneficiary action key hidden field to -1 (indicating a new beneficiary is being added)
                deathBeneficiaryActionKeyHidden.val("-1");

                // Advance the wizard to the next step (Death Beneficiary Detail step)
                wizardNextButton.click()
            });

            // Handle list item click event 
            listApi.onItemClick(function (e, context) {

                // Set the death beneficiary action key hidden field to the recordKey of the clicked item in the list
                deathBeneficiaryActionKeyHidden.val(context.recordKey);

                // Advance the wizard to the next step (Death Beneficiary Detail step)
                wizardNextButton.click()
            });    
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);